import styles from "./NoAvailabilityEmptyState.module.scss";

interface INoAvailabilityEmptyStateProps {
  phoneNumber?: string | null;
  onCallStudio: () => void;
}

export const NoAvailabilityEmptyState = ({
  phoneNumber,
  onCallStudio,
}: INoAvailabilityEmptyStateProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.illustration}>
        <div className={styles.orb}>
          <span className={styles.calendarIcon} role="img" aria-label="calendar">
            📅
          </span>
        </div>
      </div>

      <div className={styles.textBlock}>
        <h3 className={styles.title}>
          За съжаление в момента нямаме свободни дати.
        </h3>
        <p className={styles.subtitle}>
          Моля, свържете се с обекта за повече информация.
        </p>
      </div>

      {phoneNumber && (
        <button
          type="button"
          className={styles.callButton}
          onClick={onCallStudio}
        >
          <span className={styles.callIcon} role="img" aria-label="phone">
            📞
          </span>
          Обадете ни се
        </button>
      )}
    </div>
  );
};
